import { Icon, Shadow, Text, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

interface SectionLockedProps {
  title: string;
}
export const SectionLocked: React.FC<SectionLockedProps> = ({ title }) => {
  return (
    <Box mx={Spacing['inline.xxxs']} borderRadius={BoxRadius.sm}>
      <Shadow level={2} borderRadius={BoxRadius.sm}>
        <HStack
          alignItems="center"
          justifyContent="space-between"
          borderTopRadius={BoxRadius.sm}
          bg="neutral.white"
          px={Spacing['inline.xxs']}
          py={Spacing['inline.xxxs']}>
          <Text
            variant="bold"
            fontSize={Typography['fontsize.lg']}
            color={'neutral.lightest'}
            lineHeight="distant">
            {title}
          </Text>
          <Icon testId="qa" name="Locked" size="xs" color={Color['neutral.light']} />
        </HStack>
      </Shadow>
    </Box>
  );
};
